import React from "react";
import Header from "@insightfulscience/atomic-react/Header";
import Button from "@insightfulscience/atomic-react/Button";
import Navbar from "@insightfulscience/atomic-react/Navbar";
import NavbarItemLink from "@insightfulscience/atomic-react/Navbar/Link";
import NavbarItem from "@insightfulscience/atomic-react/Navbar/Item";
import NextLink from "@insightfulscience/smart-react/NextLink";
import Block from "@insightfulscience/atomic-react/Block";
import { useLocale } from "@insightfulscience/i18";
import TopBar from "@insightfulscience/topbar";
import NavbarDropdown from "@insightfulscience/atomic-react/NavbarDropdown";
import NavbarDropdownMenu from "@insightfulscience/atomic-react/NavbarDropdown/Menu";
import NavbarDropdownTitle from "@insightfulscience/atomic-react/NavbarDropdown/Title";
import SolutionsDropdown from "@src/components/SiteHeader/SolutionsDropdown";
import ProductDropdown from "@src/components/SiteHeader/ProductDropdown";
import ResourcesDropdown from "@src/components/SiteHeader/ResourcesDropdown";
import routes from "../../routes";
import prerenderedLogo from "../PrerenderedLogo";
import { isRouteEnabled } from "../../utils/routing";

type Props = {
	showTopBar?: boolean;
};

function SiteHeader({ showTopBar = true }: Props) {
	const [t] = useLocale("common");

	return (
		<>
			{showTopBar && <TopBar brandCode="om" />}
			<Header logo={prerenderedLogo} isBorderBottomNone className="">
				<Block
					utility={{ lg: { display: "flex", justify: "end" } }}
					sizing={{ lg: { w: "full" } }}
				>
					<Navbar nav="primary" type={1} data-qa-selector="navigationBar">
						<NavbarDropdown isSecondaryNav isMegaMenu>
							<NavbarDropdownTitle>{t("MENU.PRODUCT")}</NavbarDropdownTitle>
							<NavbarDropdownMenu isList={false}>
								<ProductDropdown />
							</NavbarDropdownMenu>
						</NavbarDropdown>
						<NavbarDropdown isSecondaryNav isMegaMenu>
							<NavbarDropdownTitle>{t("MENU.SOLUTIONS")}</NavbarDropdownTitle>
							<NavbarDropdownMenu isList={false}>
								<SolutionsDropdown />
							</NavbarDropdownMenu>
						</NavbarDropdown>
						<NavbarDropdown isSecondaryNav isMegaMenu>
							<NavbarDropdownTitle>{t("MENU.RESOURCES")}</NavbarDropdownTitle>
							<NavbarDropdownMenu isList={false}>
								<ResourcesDropdown />
							</NavbarDropdownMenu>
						</NavbarDropdown>
						<NavbarItem enable={isRouteEnabled(routes.helpCenter)}>
							<NextLink
								Component={NavbarItemLink}
								href={routes.helpCenter.url}
								data-qa-selector="helpCenter"
							>
								{t("MENU.SUPPORT")}
							</NextLink>
						</NavbarItem>
						<NavbarItem enable={isRouteEnabled(routes.pricing)}>
							<NextLink
								Component={NavbarItemLink}
								href={routes.pricing.url}
								data-qa-selector="pricing"
							>
								{t("MENU.PRICING")}
							</NextLink>
						</NavbarItem>
						<NavbarItem enable={isRouteEnabled(routes.signIn)}>
							<NextLink
								Component={NavbarItemLink}
								href={routes.signIn.url}
								data-qa-selector="signIn"
							>
								{t("MENU.SIGN_IN")}
							</NextLink>
						</NavbarItem>
					</Navbar>
					<Navbar nav="secondary" type={1}>
						<NavbarItem
							enable={isRouteEnabled(routes.freeTrial)}
							secondary
							className="secondary-nav__item-action"
						>
							<Button.Link
								href={routes.freeTrial.url}
								styleType="secondary"
								isOutline
								size="xs"
								data-qa-selector="freeTrialNav"
							>
								{t("TRY_FOR_FREE")}
							</Button.Link>
						</NavbarItem>
					</Navbar>
				</Block>
			</Header>
		</>
	);
}

export default SiteHeader;
